export default __webpack_public_path__ + "static/media/edyoda_transparent_logo.55bcc00f.png";